import { render, staticRenderFns } from "./Bazar.vue?vue&type=template&id=52e70a09"
import script from "./Bazar.vue?vue&type=script&lang=js"
export * from "./Bazar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports